const CustomStylesModal = {
  content : {
    background            : 'transparent',
    border                : '0',
    bottom                : 'auto',
    left                  : '50%',
    marginRight           : '-50%',
    padding               : '0',
    right                 : 'auto',
    top                   : '5px',
    transform             : 'translate(-50%, 0)',
    width                 : '380px',
  }
};

export default CustomStylesModal;
